import { render } from "./tutorialDetail.vue?vue&type=template&id=6be2d33a&scoped=true"
import script from "./tutorialDetail.vue?vue&type=script&lang=js"
export * from "./tutorialDetail.vue?vue&type=script&lang=js"

import "./tutorialDetail.vue?vue&type=style&index=0&id=6be2d33a&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6be2d33a"]])

export default __exports__